import React, { useEffect, useState } from 'react';
import { useFlowSignalsStore, flowStatusDot } from '../../store/flowSignalsStore';

const STATE_TEXT = {
  connected: 'Connected',
  offline: 'Offline',
  disabled: 'Disabled on the engine (FLOW_SIGNALS=off)',
  unknown: 'Waiting for the engine',
} as const;

export function fmtAge(ms: number | null | undefined): string {
  if (ms === null || ms === undefined) return 'never';
  const s = Math.max(0, Math.round(ms / 1000));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)}m ${s % 60}s`;
  return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
}

/** The engine's flow-signals relay: link state, freshness, and what it holds per root. */
const StatusTab: React.FC = () => {
  const status = useFlowSignalsStore((f) => f.status);
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);
  const dot = flowStatusDot(status);
  const roots = Object.entries(status?.symbols ?? {}).sort(([a], [b]) => a.localeCompare(b));

  return (
    <div className="tradefinder-status" data-testid="tradefinder-status-tab">
      <dl className="tradefinder-status-grid">
        <dt>Relay</dt>
        <dd data-testid="tradefinder-status-state">
          <span className={`tradefinder-dot is-${dot}`} aria-hidden="true" /> {STATE_TEXT[dot]}
        </dd>
        <dt>Last message</dt>
        <dd data-testid="tradefinder-status-age">
          {status?.lastMessageMs ? `${fmtAge(now - status.lastMessageMs)} ago` : 'never'}
        </dd>
        <dt>Connects</dt>
        <dd>{status?.connects ?? 0}</dd>
      </dl>
      <div className="levels-group-heading">Per root</div>
      {roots.length === 0 ? (
        <div className="levels-empty">No data from flow-signals yet</div>
      ) : (
        <table className="tradefinder-status-table" data-testid="tradefinder-status-roots">
          <thead>
            <tr><th>Root</th><th>Contract</th><th>Data lag</th><th>Signals</th></tr>
          </thead>
          <tbody>
            {roots.map(([root, st]) => (
              <tr key={root} data-testid={`tradefinder-status-root-${root}`}>
                <td>{root}</td>
                <td>{st.contract}</td>
                <td>{st.dataLagMs === null ? '-' : fmtAge(st.dataLagMs)}</td>
                <td>{st.signals.toLocaleString('en-US')}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default StatusTab;
